import React from 'react';
import { Row, Label, FormGroup } from 'reactstrap';
import constants, { courseStatic, employeeStatic } from 'config/constants';
import { selectStyle } from '../../Reports';
import { store } from 'index';
import { updateCourseId, updateEmployeeId } from 'actions/admin/employees';
import { formCourseSelectList, formEmpSelectList } from 'utils/commonFunc';
import CustomSelect from 'components/CustomSelect';
import { useSelector } from 'react-redux';

export const passEmployeeIdToStore = id => {
  store.dispatch(updateEmployeeId(id));
};

export const passCourseIdToStore = id => {
  store.dispatch(updateCourseId(id));
};

const EmpActivityFilter = (props = {}) => {
  const { loggedUserRole, employees, courses } = props;
  const reduxStore = useSelector(state => state);
  const { employees: { storeEmployeeId = 0, storeCourseId = 0 } = {} } = reduxStore;

  const employeeArr = formEmpSelectList(employees);
  const courseArr = formCourseSelectList(courses);

  const handleSelectChange = (name, selectItem) => {
    if (name === 'employeeId') {
      passEmployeeIdToStore(selectItem);
      passCourseIdToStore(0);
    } else {
      passCourseIdToStore(selectItem);
    }
  };

  return (
    <div>
      <Row>
        {(loggedUserRole === constants.roles.SA || loggedUserRole === constants.roles.admin) && (
          <div className="col-md-5">
            <FormGroup>
              <Label htmlFor="">
                <strong>
                  {employeeStatic}
                  <sup> *</sup>
                </strong>
              </Label>
              <CustomSelect
                name="employeeId"
                noLabel={true}
                value={storeEmployeeId}
                onChange={handleSelectChange}
                options={employeeArr}
                applyLabelStyle={true}
                styles={selectStyle(storeEmployeeId)}
                error={!storeEmployeeId}
              />
            </FormGroup>
          </div>
        )}
        <div className="col-md-5">
          <FormGroup>
            <Label htmlFor="">
              <strong>
                {employeeStatic} {courseStatic.toLowerCase()}
                <sup> *</sup>
              </strong>
            </Label>
            <CustomSelect
              name="courseId"
              noLabel={true}
              value={storeCourseId}
              onChange={handleSelectChange}
              options={courseArr}
              applyLabelStyle={true}
              styles={selectStyle(storeCourseId)}
              error={!storeCourseId}
            />
          </FormGroup>
        </div>
      </Row>
    </div>
  );
};

export default EmpActivityFilter;
